import {HttpInterceptorFn} from '@angular/common/http';
import {catchError, retry, timer} from "rxjs";

export const retryGetInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method !== 'GET') {
    return next(req);
  }

  return next(req)
    .pipe(
      retry({
        count: 3,
        delay: (error, retryCount) => timer(500 * retryCount)
      }),
      catchError(
        () => {
          const newReq = req.headers.has('ngsw-bypass')
            ? req
            : req.clone({ setHeaders: { 'ngsw-bypass': 'true' } });
          return next(newReq);
        }
      )
    );
}
  ;
